import { Outlet } from "react-router-dom";
import heroImage from "@/assets/images/admin-hero-bg.jpg";
import AdminHeader from "@/components/ui/AdminHeader";
import { Layout } from "antd";
import { usePageTitle } from "@/hooks/use-page-title";

const { Content } = Layout;

export default function AdminLayout() {
  usePageTitle();

  return (
    <Layout className="min-h-screen">
      <div className="relative z-20">
        <AdminHeader />
      </div>
      <Content
        className="relative"
        style={{
          minHeight: "calc(100vh - 64px)",
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="relative z-10">
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
}
